import { GridColumnType } from "../../../../../../data/gridColumnType";

export const RefrenceSynergyTaskGridConfig = {
    columns: [
        {
            name: "Action",
            fieldName: "isSelected",
            colType: GridColumnType.CHECKBOX,
            colSettings: {
                allowEdit: true
            },
            colStyle: {
                textAlign: "center",
                width: "15%"
            },
            allowShort: false
        },
        {
            name: "TaskId",
            fieldName: "taskId",
            allowShort: false,
            colStyle: {
                width: "15%",
                textAlign: "center",
            },

        },
        {
            name: "Task Title",
            fieldName: "title",
            allowShort: false,
            colStyle: {
                width: "70%",
                textAlign: "center",
            },

        },
    ],
    allowEdit: true,
    handleRowDataUpdate: null,
    OnColumnChangeEdit: null,
    hasChildGridTable: false,
}